const rules = {
  require: [{ required: true, message: '请输入', trigger: 'blur' }],
  mobile: [
    {
      required: true,
      message: '请输入手机号码',
      trigger: 'blur'
    },
    {
      validator: function(rule, value, callback) {
        if (/^1[34578]\d{9}$/.test(value) === false) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      },
      trigger: 'blur'
    }
  ]
};
export default rules;



// WEBPACK FOOTER //
// ./src/utils/formRule.js